/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import React, {useState} from 'react';

/* APP / CONTEXTOS */

import { useAppContextoReact } from '../../servicos/app/AppContextoReact';

/* COMPONENTES */

import LoadingSkeleton from '../../componentes/tabelas/LoadingSkeleton.tsx';
import AlertDialog, { IAlertConfirmDelegate } from '../../componentes/widgets/AlertConfirm';
import Bananinha, { IBananinhaDelegate } from '../../componentes/widgets/Bananinha';
import { ESTATUSFILTER, IPropsFilterObj, ETIPOFILTER } from '../../componentes/tabelas/TableFilter';

/* INTERFACES / ENUMERAÇÕES */

import FormDialog from './formDialog.tsx';
import ListComponent from '../../componentes/lists/_ListComponent';
import {EFORM} from '../../componentes/formularios/EFORM';

import { ETABLE, ITablePaginacao } from '../../componentes/tabelas/ITabelas';
import {IUserUpdate} from '../../servicos/IFormularios';
import { IUserlist, IPager } from '../../servicos/usuarios/Usuario_FrontAPI';
import { User } from 'firebase/auth';
import { areAllValuesEmpty } from '../../AppConfig';
import { useNavigate } from 'react-router-dom';

interface IPageContexto
{
	_handleAdd?: any
	_handleEdit?: any
	_handleExclude?: any
}

const PageContext = React.createContext<IPageContexto|undefined>(undefined);

const ListaUsuario = () =>
{
	const appContext = useAppContextoReact();

	const [ehCarregado, setEhCarregado] = useState<boolean>(false);
	const [deleting, setDeleting] = useState<boolean>(false);
	const [bananinhaDelegate, setBananinhaDelegate] = useState<IBananinhaDelegate|undefined>(undefined);
	const [alertConfirmDelegate, setAlertConfirmDelegate] = useState<IAlertConfirmDelegate|undefined>(undefined);
	const [listaPaginada, setListaPaginada] = useState<User[]|null>(null);
	const [openDialog, setOpenDialog] = React.useState(false);
	
	const [formEntidade, setFormEntidade] = React.useState<IUserUpdate>(null);

	const [pager, setPager] = useState<ITablePaginacao|null>(null);
	const [pageNumber, setPageNumber] = React.useState<number>();
	const [rowsPerPage, setRowsPerPage] = React.useState<number>(20);

	const [dataFilter, setDataFilter] = React.useState<IPropsFilterObj>({});
	const [drawerFilterStatus, setDrawerFilterStatus] = React.useState<ESTATUSFILTER>(ESTATUSFILTER.INICIAL);
	const [userRoleAdmin, setUserRolerAdmin] = React.useState<boolean|null|undefined>(null);
	const navigate = useNavigate();

	React.useEffect(() =>
	{
		const isAdmin = appContext.permissao.administrador
		setUserRolerAdmin(isAdmin)
		!isAdmin ? navigate('/lista-programas') : ''
	},[appContext])

	const _handleAdd = () =>
	{
		const entidade: User = {
			emailVerified: false,
			isAnonymous: false,
			metadata: undefined,
			providerData: [],
			refreshToken: '',
			tenantId: '',
			delete: null,
			getIdToken: null,
			getIdTokenResult: null,
			reload: null,
			toJSON: null,
			displayName: '',
			email: '',
			phoneNumber: '',
			photoURL: '',
			providerId: '',
			uid: ''
		}
		setFormEntidade(entidade);
		setOpenDialog(true);
	}
	const _handleEdit = (entidade:IUserUpdate) =>
	{
		setFormEntidade(entidade);
		setOpenDialog(true);
	}
	React.useEffect(() =>
	{
		setFormEntidade(formEntidade)
	},[formEntidade])

	const _delete = React.useCallback( async (ID: string) => 
	{
		setDeleting(true);
		setEhCarregado(false);
		try
		{
			const retorno = await appContext?.usuario.userDelete(ID)
			// Se página atual = última página e só tem 1 item na página
			// if (isNumber(pageNumber) && isNumber(rowsPerPage) && pageNumber == pager.total_pages && ((pager.total_items % rowsPerPage) == 1 )) {
			//	setPageNumber(Math.max(1, pageNumber - 1))
			//	}
			// Não precisa verificar o httstatus? É sempre sucesso?
			if(listaPaginada.length > 1)
					bananinhaDelegate?.abrir("Item excluído com sucesso.", "success");
		}
		catch(e)
		{
			setEhCarregado(true);
			bananinhaDelegate?.abrir(e, "error");
		}
		finally
		{
			setDeleting(false);
		}
		return '';
	}, [bananinhaDelegate, pager, rowsPerPage]) //, pageNumber
	const _handleExclude = React.useCallback((ID: string, Name: string) =>
	{
		alertConfirmDelegate?.abrir(
			"Confirme a exclusão", 
			'Deseja realmente excluir o usuário "' + Name + '"?',  
			(bln:any) => 
			{
				if(bln) _delete(ID)
			}
		)
	}, [alertConfirmDelegate, _delete])
	React.useEffect(() =>
	{
		if(!deleting)
		{
			getList(undefined,dataFilter)
		}
	},[deleting])

	const getList = async (pageToken?:string, callbackDataFilter?:IPropsFilterObj, rowsNum?:number) =>
	{
		try
		{
			setEhCarregado(false);
			const res:IUserlist = await appContext?.usuario.userList(rowsNum || rowsPerPage, pageToken, undefined, callbackDataFilter || dataFilter);
			if (res.Data?.rows) {
				setDrawerFilterStatus(ESTATUSFILTER.INICIAL);
				if (res.Data?.rows?.length > 0)
				{
					setListaPaginada(res.Data?.rows);
					if (res?.pager)
					{
						setPager(res?.pager);
						// setPageNumber(res.pager.current_page);
						setRowsPerPage(res.pager.items_per_page);
					}
				}
				else
				{
					setListaPaginada([]);
					setPager(null);
					// setPageNumber(1);
					bananinhaDelegate?.abrir('Nenhum resultado encontrado.', "error");
				}
			}
		}
		catch(e)
		{
			bananinhaDelegate?.abrir(e, "error");
		}
		finally
		{
			setEhCarregado(true);
		}
	}

	React.useEffect(() =>
	{
		setDrawerFilterStatus(ESTATUSFILTER.FECHADO);
	},[ehCarregado])

	return <>
		<PageContext.Provider value={{ _handleAdd: _handleAdd, _handleEdit: _handleEdit, _handleExclude: _handleExclude }}>
			<Bananinha getDelegate={delegate => bananinhaDelegate ?? setBananinhaDelegate(delegate)}/>
			<AlertDialog getDelegate={delegate => alertConfirmDelegate ?? setAlertConfirmDelegate(delegate)}/>
			{(ehCarregado && listaPaginada && !deleting && drawerFilterStatus) ?
				<PageContext.Consumer>{ctx => (
					<ListComponent 
						titulo="Usuários"
						addHandleAdd={() => ctx?._handleAdd()}
						addUrl={null}
						addEhNovaJanela={null}
						lstTipo={ETABLE.USER}
						lstListaPaginada={listaPaginada}
						lstPaginacao={pager}
						// lstPageNumber={pageNumber}
						lstRowsPerPage={rowsPerPage}
						lstSetup={[
							{ id: 'displayName',			numeric: false,	label: 'Nome',				sort: false,	align: 'left' },
							{ id: 'email',					numeric: false,	label: 'E-mail',			sort: false,	align: 'left' },
						]}
						lstHandleEdit={(props) => ctx?._handleEdit(props)}
						lstHandleDelete={(id, name) => ctx?._handleExclude(id, name)}
						lstFieldID="uid"
						lstFieldName="displayName"
						lstCallback={async (rowsNum) => 
							{
							setEhCarregado(false);
							setRowsPerPage(rowsNum);
							// setPageNumber(pageNum);
							await getList(undefined, undefined, rowsNum);
							}}						
						fltVisivel={true}
						fltTipoForm={ETIPOFILTER.USUARIOS}
						fltFilterDefault={dataFilter}
						fltStatus={drawerFilterStatus}
						fltFilterList={['displayName', 'email']} 
						fltCallback={async (dataFilterReturn:IPropsFilterObj) => 
							{
							// setPageNumber(1);
							if (dataFilterReturn && !areAllValuesEmpty(dataFilterReturn))
							{
								setDataFilter(dataFilterReturn);
								getList(undefined,dataFilterReturn);
							}										
							else if (dataFilterReturn && areAllValuesEmpty(dataFilterReturn))
							{
								setDataFilter({});
								getList(undefined,{});
							}
							else
								bananinhaDelegate?.abrir('Ocorreu um erro. Não foi possível filtrar.', "error");
							setDrawerFilterStatus(ESTATUSFILTER.FECHADO)
						}}
					>
						<></>
					</ListComponent>
 				)}</PageContext.Consumer>
			:
				<LoadingSkeleton columns={3} />
			}
			{
				formEntidade &&
					<FormDialog
						operacao={formEntidade.uid ? EFORM.UPDATE : EFORM.ADD}
						entidade={formEntidade}
						setEntidade={setFormEntidade}
						openDialog={openDialog}
						setOpenDialog={setOpenDialog}
						callBack={() => 
						{
							setEhCarregado(false);
							getList();
						}}
					/>
			}
		</PageContext.Provider>
	</>
}
export default ListaUsuario;
